import { Task, TaskDetail } from '../model/task';
import { CentralAction, CentralActionTypes } from './central.actions';

export const CENTRAL_FEATURE_KEY = 'central';

// Define the shape of the CentralState
export interface CentralState {
  myHelpComponents: any;
  // List of tasks and their details
  taskList: Task[];
  taskDetails: TaskDetail;
  isBusy: boolean;
  cachedSiteList: any;
  homeSite: any;
  cachedSalesPeopleList: any;
  taskSummary: any;
  activeNavIndex: number;
  taskTotalsData: any;
  openJobRequestTotals: any;
}

// Define the shape of the partial state
export interface CentralPartialState {
  readonly [CENTRAL_FEATURE_KEY]: CentralState;
}

// Initial state for the CentralState
export const initialState: CentralState = {
  myHelpComponents: null,
  // Initialize taskList and taskDetails
  taskList: [],
  taskDetails: null,
  isBusy: false,
  cachedSiteList: [],
  homeSite: null,
  cachedSalesPeopleList: [],
  taskSummary: [],
  activeNavIndex: 0,
  taskTotalsData: null,
  openJobRequestTotals: null,
};

// Reducer function to handle state changes based on actions
export function reducer(state: CentralState = initialState, action: CentralAction): CentralState {
  switch (action.type) {
    case CentralActionTypes.FETCH_MY_HELP_COMPONENTS: {
      return {
        ...state,
        isBusy: true,
      };
    }
    case CentralActionTypes.FETCH_MY_HELP_COMPONENTS_SUCCESS: {
      return {
        ...state,
        myHelpComponents: action.payload,

        isBusy: false,
      };
    }
    case CentralActionTypes.FETCH_MY_HELP_COMPONENTS_FAILED: {
      return {
        ...state,
        isBusy: false,
      };
    }
    case CentralActionTypes.LOAD_TASKS: {
      return {
        ...state,
        isBusy: true,
        taskList: [],
      };
    }
    case CentralActionTypes.LOAD_TASKS_SUCCESS: {
      return {
        ...state,
        taskList: action.payload.Tasks,
        isBusy: false,
      };
    }
    case CentralActionTypes.LOAD_TASKS_FAILED: {
      return {
        ...state,
        isBusy: false,
      };
    }
    case CentralActionTypes.LOAD_TASK_DETAILS: {
      return {
        ...state,
        isBusy: true,
      };
    }
    case CentralActionTypes.LOAD_TASK_DETAILS_SUCCESS: {
      return {
        ...state,
        taskDetails: action.payload,
        isBusy: false,
      };
    }
    case CentralActionTypes.LOAD_TASK_DETAILS_FAILED: {
      return {
        ...state,
        isBusy: false,
      };
    }
    case CentralActionTypes.UPDATE_TASK: {
      return {
        ...state,
        isBusy: true,
      };
    }
    case CentralActionTypes.UPDATE_TASK_SUCCESS: {
      return {
        ...state,
        isBusy: false,
      };
    }
    case CentralActionTypes.UPDATE_TASK_FAILED: {
      return {
        ...state,
        isBusy: false,
      };
    }
    case CentralActionTypes.FETCH_SITE_LIST: {
      if (state.cachedSiteList?.length > 0) {
        return { ...state, cachedSiteList: state.cachedSiteList, isBusy: false };
      }
      return {
        ...state,
        isBusy: true,
      };
    }
    case CentralActionTypes.FETCH_SITE_LIST_SUCCESS: {
      return {
        ...state,
        cachedSiteList: action.payload,
        isBusy: false,
      };
    }
    case CentralActionTypes.FETCH_SITE_LIST_FAILED: {
      return {
        ...state,
        isBusy: false,
      };
    }
    case CentralActionTypes.FETCH_SALESPEOPLE_LIST: {
      if (state.cachedSalesPeopleList.length > 0) {
        return {
          ...state,
          cachedSalesPeopleList: state.cachedSalesPeopleList,
          isBusy: false,
        };
      }
      return {
        ...state,
        isBusy: true,
      };
    }
    case CentralActionTypes.FETCH_SALESPEOPLE_LIST_SUCCESS: {
      return {
        ...state,
        cachedSalesPeopleList: action.payload.SearchResults,
        isBusy: false,
      };
    }
    case CentralActionTypes.FETCH_SALESPEOPLE_LIST_FAILED: {
      return {
        ...state,
        isBusy: false,
      };
    }
    case CentralActionTypes.FETCH_TASK_SUMMARY: {
      return {
        ...state,
        isBusy: true,
      };
    }
    case CentralActionTypes.FETCH_TASK_SUMMARY_SUCCESS: {
      return {
        ...state,
        taskSummary: action.payload,
        isBusy: false,
      };
    }
    case CentralActionTypes.FETCH_TASK_SUMMARY_FAILED: {
      return {
        ...state,
        isBusy: false,
      };
    }
    case CentralActionTypes.SAVE_ACTIVE_NAV_INDEX: {
      return {
        ...state,
        activeNavIndex: action.payload,
      };
    }
    case CentralActionTypes.LOAD_CENTRAL_TASKS: {
      return {
        ...state,
        isBusy: true,
      };
    }
    case CentralActionTypes.LOAD_CENTRAL_TASKS_SUCCESS: {
      return {
        ...state,
        taskTotalsData: action.payload,
        isBusy: false,
      };
    }
    case CentralActionTypes.LOAD_CENTRAL_TASKS_FAILED: {
      return {
        ...state,
        isBusy: false,
      };
    }
    case CentralActionTypes.LOAD_OPEN_JOB_REQUEST_TOTALS: {
      return {
        ...state,
        isBusy: true,
      };
    }
    case CentralActionTypes.LOAD_OPEN_JOB_REQUEST_TOTALS_SUCCESS: {
      return {
        ...state,
        openJobRequestTotals: action.payload,
        isBusy: false,
      };
    }
    case CentralActionTypes.LOAD_OPEN_JOB_REQUEST_TOTALS_FAILED: {
      return {
        ...state,
        isBusy: false,
      };
    }
    default:
      return state;
  }
}

